/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";

export default class Redirect extends Component {
  render() {
    this.props.history.push("/dashboard/content");
    return <div />;
  }
}
